import React from 'react';

export default ({value}) => {
  var formated = !value ? 0 : value.replace(/[^0-9.-]/g, "");
  return (
    <span className="percent">{formated} %</span>
  )
}



// WEBPACK FOOTER //
// ./src/components/Formaters/Percent.jsx